import React from "react";

function BackArrow(props:any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.652"
      height="15.708"
      viewBox="0 0 16.652 15.708"
    >
      <path
        fill={props.color ? props.color : '#1e2225'}
        d="M20.834 12.67H10.707l3.928-3.757a1.565 1.565 0 000-2.139 1.4 1.4 0 00-2.044 0l-6.54 6.341a1.441 1.441 0 00-.426 1.06v.019a1.441 1.441 0 00.426 1.06l6.535 6.341a1.4 1.4 0 002.044 0 1.565 1.565 0 000-2.139L10.7 15.7h10.129a1.481 1.481 0 001.448-1.514 1.466 1.466 0 00-1.443-1.516z"
        data-name="Icon ionic-md-arrow-round-back"
        transform="translate(-5.625 -6.33)"
      ></path>
    </svg>
  );
}

export default BackArrow;
